<template>
  <el-menu class="navbar" mode="horizontal"> 
    <div class="grid-wrapper">
      <div style="width:75vw; ">
        <breadcrumb />
    <div class="hearico" v-if="getMenus('repair_index')">
      <router-link   to="/repair/repair_add">
      <img src="@/assets/images/y_ico03.png"  width="30" />
      <p>快速报修</p>
      </router-link>
    </div>
    <div class="hearico" v-if="getMenus('ins_config')">
      <router-link   to="/inspectors/ins_config">
      <img src="@/assets/images/y_ico12.png"  width="30" />
      <p>定期任务</p>
    </router-link>
    </div>
      </div> 
      <span />
      <div>
        <div class="principal-wrapper" >
          <span class="label">{{username}} | {{name}}</span>
        
        <el-dropdown trigger="click" style="margin-top: -2px;">
          <div class="avatar-wrapper"> 
            <svg-icon  icon-class="user" class="user-avatar"></svg-icon>
          </div>
          <el-dropdown-menu class="user-dropdown" slot="dropdown">
            <router-link class="inlineBlock" to="/">
              <el-dropdown-item>首页</el-dropdown-item>
            </router-link>
            <el-dropdown-item divided>
              <span @click="logout" style="display: block">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        </div>
      </div>
    </div>
  </el-menu>
</template>

<script>
import logo_icon from "@/assets/images/logo.png";
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import { isMenus } from "@/utils/auth";

export default {
  data() {
    return {
      logo_icon,
    };
  },
  components: {
    Breadcrumb,
    Hamburger,
  },
  computed: {
    ...mapGetters(["menus","sidebar", "avatar","name","username"]),
  },
  created() { 
    if(this.$route.query.sel==1){ 
      setTimeout(function(){
      document.getElementById('sidebars').style.display="none";
      document.getElementById('mains').style.marginLeft="0px";
      document.getElementById('navbars').style.display="none";
      },100);
    }
  },
  methods: {
    getMenus(m) { 
      return isMenus(m, this.menus);
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .grid-wrapper {
    display: grid;
    background-color:#00599f;
    grid-template-columns: auto 1fr auto; // 左右对齐，中间弹性
    grid-template-rows: 50px;
  }
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .qrcode-wrapper {
    display: inline-block;
    padding: 0 10px;
    .label {
      float: left;
      line-height: 40px;
      padding-right: 5px;
    }
    .qrcode-svg {
      height: 30px;
      width: 30px;
      vertical-align: 0em;
      cursor: pointer;
    }
  }
  .principal-wrapper {
    display: inline-block;
    padding: 0 10px;
    .label {
      float: left;
      line-height: 40px;
      padding-right: 5px;
      color:#fff;
    }
  }
  .avatar-wrapper { 
    height: 40px; 
    cursor: pointer; 
    .user-avatar {
      width: 26px;
      height: 26px; 
      color:#fff;
    }
    .el-icon-caret-bottom {
      font-size: 22px;
    }
  }
}

.hearico{
    margin-top: 2px;
  float: right;
  width:60px; 
  img{
    width:30px; height:30px; display:block; margin:0 auto;
    line-height: 30px;
  }
  p{
    margin-top: 2px; 
    font-size: 12px;
    color:#fff;
    line-height: 12px;
    text-align: center;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue